import { render } from "./OpenStore.vue?vue&type=template&id=c4bc919e&scoped=true"
import script from "./OpenStore.vue?vue&type=script&lang=js"
export * from "./OpenStore.vue?vue&type=script&lang=js"

import "./OpenStore.vue?vue&type=style&index=0&id=c4bc919e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c4bc919e"

export default script